















import {
  defineComponent,
  ComponentInternalInstance,
  getCurrentInstance,
  Ref,
  ref,
  computed,
  onMounted,
  onUnmounted,
  watch,
  nextTick,
} from '@vue/composition-api';
import { SoundIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
export default defineComponent({
  components: {
    SoundIcon,
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;

    const isShowMsg = ref(true);
    const announcementsTextEle: Ref<null | Element> = ref(null);
    const textWidth = ref(0);
    const parentWidth = ref(0);
    // 宽度大于父级宽度才展示跑马灯
    const showAnimation = computed(() => textWidth.value > parentWidth.value);

    // 暂时只支持一条公告
    const content = computed(() => {
      const { announcements } = store.getters;
      return announcements[0] || '';
    });

    const calcWitdh = _.throttle(
      () => {
        if (announcementsTextEle.value) {
          textWidth.value = (announcementsTextEle.value as Element).clientWidth;
          parentWidth.value = ((announcementsTextEle.value as Element).parentNode as Element).clientWidth;
        }
      },
      200,
      { leading: true, trailing: true },
    );

    watch(
      () => content.value,
      (val, old) => {
        if (val && !old) {
          nextTick(() => {
            announcementsTextEle.value = vm.$refs.announcementsText as Element;
            calcWitdh();
          });
        }
      },
    );

    onMounted(() => {
      announcementsTextEle.value = vm.$refs.announcementsText as Element;
      calcWitdh();
      window.addEventListener('resize', calcWitdh);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', calcWitdh);
    });

    return {
      isShowMsg,
      content,
      showAnimation,
    };
  },
});
